import cn from "classnames";
import React, { useState } from "react";
import variableLanguage from "../../../../../../utils/hookGetVariablesLanguage";
import AuthMail from "./components/AuthMail";
import AuthPhoneMail from "./components/AuthPhoneMail";

function AuthMode({ setToggleHeaderFoter, toggleHeaderFoter, sessionId }) {
  const [variant, setVariant] = useState("email");

  const variables_63 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_63",
  });
  const variables_64 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_64",
  });
  const variables_65 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_65",
  });
  return (
    <div>
      {toggleHeaderFoter && (
        <>
          <div className="label">{variables_63}</div>
          {
            <div
              className="variant"
              onClick={() =>
                setVariant(variant === "email" ? "phone" : "email")
              }
            >
              <div className="auth-item email">{variables_64}</div>
              <div className="auth-item phone">{variables_65}</div>
              <div
                className={cn("figure", {
                  email: variant === "email",
                  phone: variant === "phone",
                })}
              />
            </div>
          }
        </>
      )}

      {variant === "email" ? (
        <AuthMail
          setToggleHeaderFoter={setToggleHeaderFoter}
          sessionId={sessionId}
        />
      ) : (
        <AuthPhoneMail
          setToggleHeaderFoter={setToggleHeaderFoter}
          sessionId={sessionId}
        />
      )}
    </div>
  );
}

export default AuthMode;
